<template>
  <div class="absolute top-0 bottom-0 w-full">
    <CurrentEventDataProvider v-slot="{ designStyles, features }">
      <SponsorsDataProvider :style="designStyles">
        <CategoriesDataProvider v-slot="{ sponsorsCategories }">
          <div class="flex flex-grow h-full" :style="designStyles">
            <div class="flex flex-col w-full h-full">
              <!--header
              <div class="space-y-2 p-4">
                <div class="text-md font-bold">
                  {{ data.captions.sponsorsCaption }}
                </div>
              </div>-->
              <!-- body -->
              <!-- Filter bar -->
              <div
                v-if="features.sponsorFilter"
                class="p-4 flex w-full space-x-2 items-center"
              >
                <Filters
                  showSearchFilter
                  @search-filter="handleSearchFilter"
                  showCategories
                  :categories="sponsorsCategories"
                  @category-filter="handleChangeCategory"
                />
              </div>
              <div
                class="flex-grow h-auto overflow-y-auto overflow-x-hidden p-2"
              >
                <div
                  v-for="(sponsor, i) in displayedItems"
                  :key="sponsor.id"
                  :item-id="i"
                >
                  <Card
                    :class="'p-4 mx-0 md:mx-12 lg:mx-0 mb-4 rounded-md bg-white space-y-4'"
                  >
                    <router-link
                      tag="button"
                      :to="{
                        name: 'sponsor',
                        params: { sponsorId: sponsor.id }
                      }"
                    >
                      <div
                        class="flex justify-center hover:opacity-75 focus:outline-none"
                      >
                        <div class="pr-4 w-1/3">
                          <img
                            :src="
                              sponsor.logoUrl ? sponsor.logoUrl : defaultSource
                            "
                            :alt="sponsor.name"
                            :class="customStylingForImage"
                            @click="onNavigationAwayFromCard()"
                          />
                        </div>
                        <div class="w-2/3 flex flex-col justify-center">
                          <h3
                            class="text-xs md:text-sm lg:text-base font-bold text-center py-2"
                          >
                            {{ sponsor.name }}
                          </h3>
                        </div>
                      </div>
                    </router-link>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </CategoriesDataProvider>
      </SponsorsDataProvider>
    </CurrentEventDataProvider>
  </div>
</template>

<script>
import Card from '@/components/shared/webapp/Card';
import Filters from '@/components/shared/Filters';
import { mapGetters, mapMutations } from 'vuex';
import CategoriesDataProvider from '@/components/providers/CategoriesDataProvider.vue';
export default {
  name: 'Sponsor',
  components: { Card, Filters },
  data() {
    return {
      filter: '',
      categoryFilter: ''
    };
  },
  props: {
    customStylingForImage: {
      type: String,
      default: 'min-h-16 max-h-36 w-auto'
    }
  },
  computed: {
    ...mapGetters('Sponsor', ['getDefaultCompanyLogoUrl']),
    defaultSource() {
      return this.getDefaultCompanyLogoUrl;
    },
    displayedItems() {
      return this.filterSponsors();
    }
  },
  methods: {
    ...mapMutations('Sponsor', ['setLastPage']),
    onNavigationAwayFromCard() {
      if (this.$route.name !== 'sponsor') {
        this.setLastPage({
          name: this.$route.name,
          fullPath: this.$route.fullPath
        });
      }
    },

    handleSearchFilter(e) {
      this.filter = e;
    },
    filterSponsors() {
      let items = this.$store.getters['Sponsors/getItems'];

      if (this.filter) {
        items = items.filter((sponsor) => {
          const fullName = `${sponsor.name}`;
          return fullName.toLowerCase().includes(this.filter.toLowerCase());
        });
      }

      if (this.categoryFilter) {
        items = items.filter((sponsor) => {
          return (
            sponsor.categories &&
            sponsor.categories.some(
              (category) =>
                category.value.toLowerCase() ===
                this.categoryFilter.toLowerCase()
            )
          );
        });
      }

      return items;
    },
    handleChangeCategory(value) {
      this.categoryFilter = value;
    }
  }
};
</script>
